import { render } from "./ResultSearch.vue?vue&type=template&id=3896114f&scoped=true"
import script from "./ResultSearch.vue?vue&type=script&lang=js"
export * from "./ResultSearch.vue?vue&type=script&lang=js"

import "./ResultSearch.vue?vue&type=style&index=0&id=3896114f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3896114f"]])

export default __exports__